/**
 * Relative Time — auto-updating "Xm ago" / "Xh ago" for recent timestamps.
 * Finds <time data-relative datetime="..."> elements, converts recent ones
 * to relative format, and refreshes every 60s.
 */
(function () {
  function updateRelativeTimes() {
    var now = Date.now();
    document.querySelectorAll('time[data-relative]').forEach(function (el) {
      var iso = el.getAttribute('datetime');
      if (!iso) return;
      var ts = new Date(iso).getTime();
      var diff = now - ts;
      if (diff < 0 || isNaN(diff)) return;

      var minutes = Math.floor(diff / 60000);
      var hours = Math.floor(diff / 3600000);
      var days = Math.floor(diff / 86400000);

      if (minutes < 1) {
        el.textContent = 'just now';
      } else if (minutes < 60) {
        el.textContent = minutes + 'm ago';
      } else if (hours < 24) {
        el.textContent = hours + 'h ago';
      } else if (days < 7) {
        el.textContent = days + 'd ago';
      } else if (days < 28) {
        el.textContent = Math.floor(days / 7) + 'w ago';
      }
      // 4w+ — leave original text (formatted date from server)
    });
  }

  document.addEventListener('DOMContentLoaded', updateRelativeTimes);
  document.body.addEventListener('htmx:afterSettle', updateRelativeTimes);
  setInterval(updateRelativeTimes, 60000);

  // Time-column toggle — flip the table between relative ("1d ago") and the absolute
  // timestamp. CSS (.times-absolute) shows/hides the <time> vs the .time-abs span.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-toggle-times]');
    if (!toggle) return;
    var scope = toggle.closest('table') || document.body;
    scope.classList.toggle('times-absolute');
  });
})();
